import { Card } from '../../logic/card/card';
import { SolitaireGameRunner } from '../../model/solitaire-game-runner';
import { SolitaireListener } from '../solitaire-listener';

export class GameRunnerService {
  public get onNewDealStartedTrigger() {
    return this.solitaireGameRunner.onNewDealStartedTrigger;
  }
  public get onNewDealFinishedTrigger() {
    return this.solitaireGameRunner.onNewDealFinishedTrigger;
  }
  public get onPossibleHintsTrigger() {
    return this.solitaireGameRunner.onPossibleHintsTrigger;
  }
  public get onBoardChangedTrigger() {
    return this.solitaireGameRunner.onBoardChangedTrigger;
  }
  public get onGameStateChangedTrigger() {
    return this.solitaireGameRunner.onGameStateChangedTrigger;
  }
  public get currentGame() {
    return this.solitaireGameRunner.currentGame;
  }
  public get allCardsDisclosed() {
    return this.solitaireGameRunner.currentGame?.allCardsDisclosed ?? true;
  }

  private readonly solitaireGameRunner: SolitaireGameRunner;

  constructor(solitaireListener: SolitaireListener) {
    this.solitaireGameRunner = new SolitaireGameRunner(solitaireListener);
  }

  public createLocalGame(logicVersion: number) {
    this.solitaireGameRunner.startNewLocalRound(logicVersion);
  }

  public drawNextCard() {
    this.solitaireGameRunner.clickDeck();
  }

  public autoMoveCard(card: Card): boolean {
    return this.solitaireGameRunner.autoMoveCard(card);
  }

  public autoFinishNextCard(): boolean {
    return this.solitaireGameRunner.autoFinishNextCard();
  }

  public onCardPlaced(card: Card) {
    this.solitaireGameRunner.onCardPlaced(card);
  }

  public gameComplete() {
    this.solitaireGameRunner.gameComplete();
  }

  public startNewRemoteRound(logicVersion: number): void {
    this.solitaireGameRunner.startNewRemoteRound(logicVersion);
  }

  public startExistingRemoteRound(moves: string[], logicVersion: number): void {
    this.solitaireGameRunner.startExistingRemoteRound(moves, logicVersion);
  }

  public startGame() {
    this.solitaireGameRunner.clickStartGame();
  }

  public hint() {
    this.solitaireGameRunner.clickHint();
  }

  public undo() {
    this.solitaireGameRunner.clickUndo();
  }
}
